import script from "./DashboardSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSettings.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSettings.vue?vue&type=style&index=0&id=f7a3e74c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7a3e74c"]])

export default __exports__